import { render, staticRenderFns } from "./CubeList.vue?vue&type=template&id=c8db9f2a&scoped=true"
import script from "./CubeList.vue?vue&type=script&lang=js"
export * from "./CubeList.vue?vue&type=script&lang=js"
import style0 from "./CubeList.vue?vue&type=style&index=0&id=c8db9f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8db9f2a",
  null
  
)

export default component.exports